"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _this = void 0;

var months = '一_二_三_四_五_六_七_八_九_十_十一_十二'.split('_').map(function (v) {
  (0, _newArrowCheck2.default)(this, _this);
  return "".concat(v, "\u6708");
}.bind(void 0));
var weekdays = '日_一_二_三_四_五_六'.split('_');
var _default = {
  month: '月',
  year: '年',
  monthBeforeYear: false,
  months: months,
  weekdays: weekdays
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Calendar/locale/zh_CN.js
// module id = 1669
// module chunks = 6 7 17 18